import { Controller } from "@hotwired/stimulus";
import { paintRangeFill } from "../lib/range_fill";

/** Un curseur (`Ui::RangeComponent`) : sa piste se remplit jusqu'à la valeur, à chaque mouvement. */
export default class extends Controller<HTMLInputElement> {
  connect(): void {
    this.paint();
  }

  paint(): void {
    paintRangeFill(this.element);
  }
}
